export const translations = {
  it: {
    nav: { how: "Come funziona", features: "Funzionalità", sectors: "Settori", book: "Libro", pricing: "Piani", contact: "Contatti", login: "Accedi", cta: "Prova la Dashboard" },
    book: {
      badge: "Novità editoriale — Aldebran Edizioni",
      title: "Il Regolamento Europeo Macchine 2023/1230",
      subtitle: "Dalla Direttiva 2006/42/CE alla nuova disciplina europea",
      desc: "La guida applicativa al nuovo Regolamento (UE) 2023/1230: obblighi del fabbricante, marcatura CE, valutazione dei rischi e sicurezza della macchina nel passaggio dalla Direttiva Macchine 2006/42/CE alla nuova disciplina europea. Uno strumento operativo per fabbricanti, progettisti e consulenti che devono adeguare documentazione tecnica e processi alle nuove regole.",
      author: "Autore", authorName: "Antonio Del Mastro",
      publisher: "Editore", publisherName: "Aldebran Edizioni",
      date: "Pubblicazione", dateValue: "18 ottobre 2026",
      format: "Formato", formatValue: "Copertina rigida",
      cta: "Acquista su Amazon",
      note: "Disponibile su Amazon.it",
    },
    hero: {
      overline: "Regolamento Macchine UE 2023/1230",
      title1: "La conformità",
      title2: "delle tue macchine",
      title3: "a portata di QR Code",
      subtitle:
        "Digitalizza il Fascicolo Tecnico, i manuali d'istruzione e i disegni dei tuoi macchinari industriali in piena conformità con il Regolamento Macchine UE 2023/1230. Conservazione a norma di legge per 10 anni.",
      cta: "Prova la Dashboard Fabbricanti",
      secondary: "Scopri come funziona",
      stat1: "Anni di archiviazione garantita",
      stat2: "Conformità normativa",
      stat3: "Accesso sul campo",
    },
    marquee: ["ISO 9001", "UE 2023/1230", "CONFORMITÀ", "SICUREZZA INDUSTRIALE", "DICHIARAZIONE UE", "QR CODE", "ARCHIVIO 10 ANNI"],
    features: {
      overline: "La piattaforma",
      title: "Tutto ciò che serve per la conformità digitale",
      subtitle: "Quattro pilastri per gestire la documentazione tecnica dei tuoi macchinari, dal fabbricante all'ispettore.",
      items: [
        { t: "Generazione Targa Digitale", d: "Creazione dinamica del QR Code per ogni macchinario, univoco e sempre tracciabile." },
        { t: "Fascicolo Tecnico & Cloud Sicuro", d: "Hosting protetto di manuali, Dichiarazioni UE e fascicolo tecnico per 10 anni: cartelle personalizzabili, note, ricerca globale, anteprima documenti e report PDF stampabile con il tuo logo." },
        { t: "Ottimizzazione Mobile", d: "Consultazione immediata e fluida direttamente sul campo per operatori e ispettori." },
        { t: "Automazione di Stampa", d: "Generazione istantanea del PDF del layout di targa pronto da stampare, direttamente dalla piattaforma." },
      ],
    },
    how: {
      overline: "Come funziona",
      title: "Dalla scrivania al macchinario in tre passaggi",
      steps: [
        { t: "Inserisci i dati tecnici", d: "Registra i dati tecnici del macchinario nella tua dashboard privata e protetta." },
        { t: "Carica i documenti e il Fascicolo", d: "Allega i manuali d'istruzione, le Dichiarazioni CE/UE e l'intero fascicolo tecnico in formati estesi (fino a 100MB per file)." },
        { t: "Genera e applica il QR", d: "Genera l'etichetta con il QR Code direttamente dalla piattaforma e applicala sul macchinario." },
      ],
    },
    cta: { title: "Pronto a digitalizzare la conformità?", subtitle: "Attiva la tua Dashboard Fabbricanti e genera la prima targa digitale in pochi minuti.", button: "Inizia Ora" },
    sectors: {
      overline: "Settori",
      title: "Un'unica piattaforma per ogni esigenza di Compliance",
      items: [
        { tag: "ISO 9001", t: "Qualità", d: "Controllo documentale al punto d'uso. Aggiorni le istruzioni operative sul cloud e il QR nei reparti resta identico. Audit ispettivi sempre superati senza carta obsoleta." },
        { tag: "PED", t: "Pressione", d: "Archiviazione decennale e inalterabile di dichiarazioni e certificati dei materiali (3.1) direttamente su valvole o serbatoi, pronti per le verifiche sul posto." },
        { tag: "ATEX", t: "Esplosivi", d: "Consultazione immediata a bordo macchina dei registri di manutenzione obbligatori e dei limiti di sicurezza dei componenti in zone a rischio." },
        { tag: "MDR", t: "Medicali", d: "Disponibilità immediata dei manuali d'uso e dei certificati dei dispositivi per operatori sanitari e sorveglianza post-market." },
        { tag: "MANUTENZIONE", t: "Officine & Impianti", d: "Abbina i codici QR alle schede macchina e agli impianti di qualunque settore. Gestisci in mobilità manutenzioni programmate, scadenze di taratura, verbali di verifica periodica e registri storici direttamente sul posto, azzerando i tempi di ricerca in officina." },
        { tag: "CONSUMER", t: "Prodotti Consumer", d: "Anticipa l'obbligo europeo del DPP (Digital Product Passport). Sostituisci i manuali cartacei di elettrodomestici, IoT e prodotti tech con un QR Code che offre manuali multilingua, guide di smaltimento riciclo e registrazione garanzia." },
        { tag: "CYBERSECURITY", t: "Software di Sicurezza", d: "Identifica l'integrità del software industriale e dei PLC di sicurezza a bordo macchina. Inserisci il QR Code direttamente sugli schermi HMI o nel codice per tracciare Distinte Base del Software (SBOM), patch di sicurezza e log contro le manomissioni (Cyber Resilience Act)." },
        { tag: "AUTOMAZIONE", t: "Quadri Elettrici", d: "Associa a ogni quadro elettrico, PLC o impianto bordo macchina gli schemi aggiornati, i report di collaudo e le distinte componenti. Semplifica la manutenzione sul campo e l'assistenza post-vendita eliminando i faldoni cartacei." },
        { tag: "AEROSPACE", t: "Aerospace & Difesa", d: "Traccia ogni componente critico con massima accuratezza e gestisci la complessa documentazione di conformità aeronautica. Garantisci la reperibilità immediata di certificati dei materiali, relazioni di prova e registri storici di ispezione." },
        { tag: "CONSULENZA", t: "Sistemi di Gestione", d: "Digitalizza i punti d'uso dei flussi aziendali legati a Qualità, Sicurezza e Ambiente (ISO 9001, 14001, 45001). Consenti a consulenti e auditor interni l'accesso istantaneo alle procedure controllate, ai verbali di audit e alle check-list di conformità." },
      ],
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo del tuo parco macchine",
      subtitle: "Hai domande sulla piattaforma, sui pacchetti o vuoi una demo guidata? Scrivici: ti rispondiamo entro un giorno lavorativo.",
      nameLabel: "Nome / Azienda",
      namePlaceholder: "Mario Rossi — Officina Rossi Srl",
      messageLabel: "Messaggio",
      messagePlaceholder: "Raccontaci la tua esigenza: quante macchine gestisci, che documentazione vuoi digitalizzare...",
      cta: "Invia la richiesta",
      success: "Richiesta inviata con successo!",
      error: "Invio non riuscito. Riprova tra qualche istante.",
      tooMany: "Troppe richieste: riprova tra un'ora.",
      sentTitle: "Grazie, messaggio ricevuto!",
      sentSub: "Ti risponderemo al più presto all'indirizzo email indicato.",
    },
    pricing: {
      overline: "Piani e Tariffe",
      title: "Un piano per ogni parco macchine",
      subtitle: "Abbonamento software e archiviazione legale separati: paghi solo ciò che ti serve.",
      platform: {
        heading: "Abbonamento Piattaforma",
        desc: "Generazione targhe QR e Dashboard Fabbricanti.",
        monthly: "Mensile", annual: "Annuale",
        priceMonthly: "€19", perMonth: "/mese",
        priceAnnual: "€190", perYear: "/anno",
        annualBadge: "2 mesi gratis",
        features: [
          "Generazione codici QR e macchinari illimitati",
          "Accesso completo alla Dashboard Fabbricanti",
          "Modifiche ai dati dei macchinari in ogni momento",
          "Condivisione immediata della targa via Email ai clienti",
          "Pagina pubblica condivisibile del QR (/m/{id}) ottimizzata in 5 lingue UE",
          "Foto, descrizione e link video della macchina sulla pagina pubblica",
          "Statistiche di scansione QR in Dashboard: totali, storico con date e località, esportazione CSV",
          "Duplicazione dei macchinari con un click",
          "Visualizzazione del logo del fabbricante sulla pagina pubblica",
          "Anteprima visiva della targa digitale inclusa",
          "Supporto tecnico via email",
        ],
        cta: "Attiva l'abbonamento",
      },
      archive: {
        heading: "Pacchetti Archiviazione Decennale Legale",
        desc: "Caricamento protetto dei manuali obbligatori, conservati per 10 anni. Pagamento una tantum.",
        oneTime: "Una tantum",
        plans: [
          { name: "Pacchetto Archivio Base", price: "€149", features: [
            "Archivio protetto e blindato per un massimo di 10 macchinari",
            "Caricamento del SOLO Manuale d'istruzioni e della Dichiarazione CE/UE per ciascuna macchina",
            "Editor visuale per applicare la targa QR direttamente sul manuale PDF e sulla Dichiarazione CE/UE",
            "Conservazione digitale e legale garantita per 10 anni (Regolamento Macchine)",
            "Consultazione pubblica dei documenti immediata tramite QR Code",
            "Layout targa istituzionale con co-branding (Logo Cliente in alto a sinistra + Logo CertificoQR in alto a destra)",
            "Logica di blocco automatico al raggiungimento del limite dei 10 manuali",
            "Calcolo automatico dell'IVA al checkout e fatturazione italiana a norma di legge",
          ] },
          { name: "Pacchetto Archivio Pro", price: "€599", features: [
            "Archivio aziendale protetto per un massimo di 100 macchinari",
            "Caricamento del SOLO Manuale d'istruzioni e della Dichiarazione CE/UE per ciascuna macchina",
            "Editor visuale per applicare la targa QR direttamente sul manuale PDF e sulla Dichiarazione CE/UE",
            "Conservazione digitale e legale garantita per 10 anni (Regolamento Macchine)",
            "Layout targa istituzionale avanzato con doppio logo (Azienda + CertificoQR)",
            "Esportazione massiva dei dati dei macchinari in formato CSV",
            "Download istantaneo di tutte le targhe generate in un unico pacchetto ZIP",
            "Integrazione nativa con il Portale Clienti Stripe in Dashboard per la gestione autonoma di fatture e ricevute",
            "Logica di blocco automatico al raggiungimento del limite dei 100 manuali",
          ] },
          { name: "Pacchetto Fascicolo Pro", price: "€999", features: [
            "Archiviazione completa del Fascicolo Tecnico (Direttiva Macchine)",
            "Massimo 100 macchine con documenti e fascicolo associato",
            "Fino a 5 GB di spazio totale per ciascuna macchina",
            "Supporto formati estesi (PDF, Word, immagini, disegni CAD DWG/DXF)",
            "Limite massimo per singolo file elevato a 100 MB",
            "Organizzazione in cartelle e sottocartelle personalizzabili con note per documento",
            "Ricerca globale dei documenti, anteprima PDF/immagini e download ZIP dell'intero fascicolo",
            "Report PDF stampabile del fascicolo con il logo della tua azienda, anche unico per l'intero parco macchine",
            "Conservazione legale e immutabile per 10 anni",
            "Layout targa avanzato con co-branding (Azienda + CertificoQR)",
            "Esportazione massiva CSV e download ZIP di tutte le targhe",
          ] },
        ],
        cta: "Acquista il pacchetto",
      },
      faq: {
        title: "Domande frequenti",
        items: [
          { q: "Quali documenti posso caricare?", a: "Con i pacchetti Archivio Base e Pro puoi caricare documenti di conformità, istruzioni operative ISO, certificati PED/ATEX/MDR e manuali consumer. Con il pacchetto Fascicolo Pro sblocchi anche il caricamento dell'intero fascicolo tecnico interno (disegni CAD DWG/DXF, relazioni, cybersecurity log e analisi rischi) fino a 5 GB per singola macchina." },
          { q: "Come organizzo e consulto il Fascicolo Tecnico?", a: "Il fascicolo si organizza in cartelle e sottocartelle personalizzabili (fino a 3 livelli), con la possibilità di spostare i documenti e aggiungere note. Trovi ogni documento con la ricerca globale su tutte le macchine, lo visualizzi in anteprima senza scaricarlo e puoi esportare l'intero fascicolo in ZIP o generare un report PDF stampabile con l'indice dei documenti e il logo della tua azienda." },
          { q: "Cosa vede il cliente quando scansiona il QR Code?", a: "Il cliente apre la pagina pubblica della macchina con foto, descrizione, video di presentazione (se caricati), dati tecnici in evidenza e i documenti pubblici disponibili (Manuale d'istruzioni e Dichiarazione CE/UE). Il Fascicolo Tecnico interno resta sempre privato e visibile solo dal fabbricante in Dashboard." },
          { q: "Come funziona la fatturazione?", a: "Al checkout Stripe l'IVA viene calcolata automaticamente e riceverai una fattura italiana a norma di legge con i dati fiscali inseriti (Partita IVA, Codice Fiscale, Ragione Sociale)." },
          { q: "Posso disdire l'abbonamento quando voglio?", a: "Sì. Dalla Dashboard accedi al Portale Clienti Stripe e gestisci in autonomia disdetta, fatture e ricevute. L'abbonamento resta attivo fino alla fine del periodo pagato." },
          { q: "Cosa succede se raggiungo il limite di manuali?", a: "Il caricamento si blocca automaticamente al raggiungimento del limite del pacchetto (10 o 100 manuali). Puoi passare al Pacchetto Archivio Pro in qualsiasi momento per estendere lo spazio." },
        ],
      },
      compare: {
        title: "Confronto pacchetti archivio",
        intro: "Non vendiamo semplice spazio cloud: CertificoQR è una struttura organizzata a norma di legge, con archiviazione blindata e immutabile che tutela la responsabilità penale del fabbricante per 10 anni.",
        base: "Archivio Base", pro: "Archivio Pro", fascicolo: "Fascicolo Pro",
        rows: [
          { f: "Macchinari archiviati", b: "10", p: "100", x: "100" },
          { f: "Manuale + Dichiarazione CE/UE per macchina", b: "✓", p: "✓", x: "✓" },
          { f: "Conservazione legale e immutabile 10 anni", b: "✓", p: "✓", x: "✓" },
          { f: "Consultazione pubblica via QR Code", b: "✓", p: "✓", x: "✓" },
          { f: "Pagina pubblica con foto, descrizione e video della macchina", b: "✓", p: "✓", x: "✓" },
          { f: "Statistiche delle scansioni QR con storico dettagliato ed esportazione CSV", b: "✓", p: "✓", x: "✓" },
          { f: "Targa con co-branding (doppio logo)", b: "✓", p: "✓ avanzato", x: "✓ avanzato" },
          { f: "Esportazione massiva CSV", b: "—", p: "✓", x: "✓" },
          { f: "Download ZIP di tutte le targhe", b: "—", p: "✓", x: "✓" },
          { f: "Portale Clienti Stripe in Dashboard", b: "—", p: "✓", x: "✓" },
          { f: "Applicazione QR sul manuale PDF (editor visuale)", b: "✓", p: "✓", x: "—" },
          { f: "Archiviazione Fascicolo Tecnico Completo (disegni CAD DWG/DXF, immagini, file fino a 100MB, 5GB per macchina)", b: "—", p: "—", x: "✓" },
          { f: "Cartelle e sottocartelle personalizzabili, note, ricerca globale e anteprima documenti", b: "—", p: "—", x: "✓" },
          { f: "Report PDF del fascicolo con logo aziendale (singola macchina e parco completo)", b: "—", p: "—", x: "✓" },
          { f: "Download ZIP dell'intero fascicolo con struttura cartelle", b: "—", p: "—", x: "✓" },
          { f: "Prezzo una tantum", b: "€149", p: "€599", x: "€999" },
        ],
      },
    },
    thanks: {
      title: "Grazie per il tuo acquisto!",
      subtitle: "Il pagamento è andato a buon fine. Il tuo piano verrà attivato automaticamente entro pochi istanti.",
      emailNote: "Importante: l'attivazione avviene sull'account CertificoQR registrato con la stessa email usata per il pagamento. Se non hai ancora un account, registrati con quella email.",
      ctaRegister: "Crea il tuo account",
      ctaLogin: "Accedi alla Dashboard",
      checking: "Stiamo verificando l'attivazione del tuo piano...",
      timeout: "L'attivazione sta richiedendo più del previsto: apri la dashboard, il piano comparirà a breve. Per assistenza: certificoqr@aldebran.com",
      activated: "Piano attivato! Ti stiamo portando alla dashboard...",
      goDashboard: "Vai alla Dashboard",
    },
    about: {
      title: "Chi siamo",
      overline: "Azienda",
      text: "CertificoQR è un servizio di Aldebran",
      website: "www.aldebran.com",
      address: "Via Dalmine, 10a · 24035 Curno (BG)",
      phone: "+39 035 0167428",
      email: "certificoqr@aldebran.com",
      back: "Torna alla home",
    },
    footer: {
      tagline: "La conformità delle tue macchine, digitalizzata.",
      product: "Prodotto", legal: "Legale", company: "Azienda",
      links: { features: "Funzionalità", how: "Come funziona", dashboard: "Dashboard", privacy: "Privacy Policy", terms: "Termini di Servizio", cookie: "Cookie Policy", about: "Chi siamo", contact: "Contatti", support: "Assistenza" },
      rights: "Tutti i diritti riservati.",
    },
    auth: {
      loginTitle: "Accedi alla tua dashboard", loginSub: "Gestisci la conformità dei tuoi macchinari.",
      forgotLink: "Password dimenticata?", backToLogin: "Torna al login",
      forgotTitle: "Recupera la password", forgotSub: "Ti invieremo un link via email per reimpostarla.",
      forgotCta: "Invia link di recupero",
      forgotSent: "Se esiste un account con questa email, riceverai un link di recupero a breve.",
      resetTitle: "Imposta una nuova password", resetValidating: "Verifica del link di recupero in corso...",
      resetInvalid: "Questo link di recupero non è valido o è scaduto. Richiedine uno nuovo dal login.",
      resetNew: "Nuova password", resetConfirm: "Conferma password",
      resetTooShort: "Usa almeno 8 caratteri.", resetMismatch: "Le password non coincidono.",
      resetCta: "Aggiorna password", resetDone: "Password aggiornata! Ti stiamo riportando al login...",
      regTitle: "Crea il tuo account", regSub: "Attiva la Dashboard Fabbricanti in pochi secondi.",
      email: "Email", password: "Password", login: "Accedi", register: "Registrati",
      noAccount: "Non hai un account?", haveAccount: "Hai già un account?", signup: "Registrati", signin: "Accedi",
      confirm: "Controlla la tua email per confermare l'account, poi accedi.", back: "Torna alla home",
    },
    adminReq: {
      title: "Richieste di contatto dal sito",
      empty: "Nessuna richiesta ricevuta.",
      sent: "Email inoltrata",
      pending: "Email in coda (verrà inviata al ripristino del dominio)",
      deleted: "Richiesta eliminata",
      error: "Operazione non riuscita",
      newOne: "nuova", newMany: "nuove", newChip: "NUOVA",
      markRead: "Segna tutte come lette",
      marked: "Richieste segnate come lette",
    },
    stats: {
      title: "Panoramica Scansioni",
      total: "Scansioni totali",
      thisMonth: "Questo mese",
      showDetail: "Mostra dettaglio scansioni",
      hideDetail: "Nascondi dettaglio",
      exportCsv: "Esporta CSV",
      exportError: "Esportazione non riuscita",
      top: "Macchina più scansionata",
      chart: "Ultimi 12 mesi",
    },
    dossier: {
      title: "Fascicolo Tecnico",
      regulation: "Regolamento Macchine UE 2023/1230",
      privateNote: "Documentazione interna riservata: visibile solo in questa dashboard, mai sulla pagina pubblica del QR.",
      required: "Il Fascicolo Tecnico richiede il Pacchetto Fascicolo Pro (€999 una tantum): acquistalo dalla sezione Piani di certificoqr.com.",
      category: "Categoria documento",
      categories: {
        drawings: "Disegni complessivi e schemi",
        calculations: "Calcoli e prove tecniche",
        risk: "Valutazione dei rischi",
        standards: "Norme applicate",
        other: "Altri documenti",
      },
      upload: "Carica file",
      formats: "Formati: PDF, DOC/DOCX, DWG, DXF, PNG, JPG · max 100MB per file",
      space: "Spazio fascicolo",
      empty: "Nessun documento nel fascicolo. Carica disegni, calcoli e valutazioni dei rischi.",
      uploaded: "Documento caricato nel fascicolo",
      deleted: "Documento eliminato",
      confirmDelete: "Eliminare questo documento dal fascicolo?",
      badFormat: "Formato non consentito (PDF, DOC/DOCX, DWG, DXF, PNG, JPG)",
      tooLarge: "File troppo grande (max {max})",
      quotaFull: "Spazio fascicolo esaurito (max {quota} per macchinario)",
      uploadError: "Errore durante il caricamento",
      downloadError: "Errore durante il download",
      download: "Scarica",
      delete: "Elimina",
      open: "Fascicolo",
      foldersLabel: "Cartelle del fascicolo",
      newFolder: "Nuova cartella",
      folderName: "Nome cartella (libero o preimpostato)",
      uploadInto: "Carica nella cartella",
      noFolders: "Nessuna cartella. Crea la prima cartella per organizzare il fascicolo: puoi darle il nome che vuoi o scegliere un nome preimpostato.",
      rename: "Rinomina",
      folderCreated: "Cartella creata",
      folderRenamed: "Cartella rinominata",
      folderDeleted: "Cartella eliminata",
      folderNotEmpty: "La cartella contiene file o sottocartelle: spostali o eliminali prima",
      subFolder: "Sottocartella",
      moveFile: "Sposta in un'altra cartella",
      moved: "Documento spostato",
      maxDepth: "Profondità massima raggiunta (3 livelli)",
      zipBtn: "Scarica ZIP",
      zipStarted: "Download del fascicolo avviato",
      search: "Cerca documento...",
      noResults: "Nessun documento trovato",
      preview: "Anteprima",
      globalTitle: "Ricerca globale nel Fascicolo Tecnico",
      globalPlaceholder: "Cerca un documento in tutte le macchine...",
      noteLabel: "Nota",
      notePlaceholder: "Aggiungi una nota al documento...",
      noteSaved: "Nota salvata",
      docOne: "documento",
      docMany: "documenti",
      reportBtn: "Report PDF",
      reportStarted: "Download del report avviato",
      reportAllBtn: "Report completo PDF",
    },
    qredit: {
      title: "Applica QR sul Manuale",
      subtitle: "Trascina e ridimensiona il riquadro QR nel punto desiderato della pagina, poi salva.",
      page: "Pagina",
      of: "di",
      save: "Imprimi QR sul PDF",
      saving: "Generazione PDF...",
      saved: "QR impresso sul manuale con successo",
      restore: "Ripristina originale",
      restored: "Manuale originale ripristinato",
      stampedNote: "Questo manuale ha già un QR impresso: riposizionandolo si riparte sempre dal PDF originale pulito.",
      error: "Operazione non riuscita, riprova",
      loadError: "Impossibile caricare il manuale",
      previewBtn: "Anteprima timbro",
      previewNote: "Anteprima esatta della pagina timbrata: se la posizione è corretta, salva; altrimenti torna a modificare.",
      backEdit: "Modifica posizione",
      guideTitle: "Come funziona l'editor",
      guideSteps: [
        "Trascina il riquadro QR nel punto desiderato della pagina",
        "Ridimensiona con la maniglia verde in basso a destra",
        "Controlla il risultato con \"Anteprima timbro\"",
        "Salva: il PDF viene rigenerato con il QR impresso",
      ],
      guideOk: "Ho capito, iniziamo",
      hint: "Il QR resta nero su riquadro bianco con il numero di serie, per garantire stampa e scansione perfette.",
    },
    dash: {
      title: "Dashboard Fabbricanti", welcome: "Benvenuto", logout: "Esci",
      add: "Nuovo macchinario", empty: "Nessun macchinario registrato. Aggiungi il primo per generare la targa digitale.",
      name: "Nome macchinario", model: "Modello", serial: "Numero di serie", manufacturer: "Fabbricante", year: "Anno di costruzione",
      manual: "URL Manuale (PDF)", declaration: "URL Dichiarazione UE (PDF)", save: "Salva macchinario", cancel: "Annulla",
      generate: "Genera targa QR", generating: "Generazione...", generated: "Targa generata", viewPdf: "Visualizza PDF", delete: "Elimina",
      count: "macchinari registrati",
      manualFile: "Manuale d'istruzione (PDF)", declFile: "Dichiarazione UE (PDF)", optional: "Facoltativo",
      uploadHint: "Carica un file PDF (max 20MB)", uploading: "Caricamento documenti...", docs: "Documenti",
      manualShort: "Manuale", declShort: "Dichiarazione UE",
      companyLogo: "Logo aziendale",
      edit: "Modifica", editTitle: "Modifica macchinario", updateSave: "Salva modifiche", updatedToast: "Macchinario aggiornato",
      search: "Cerca per nome, seriale o fabbricante...", noResults: "Nessun macchinario corrisponde alla ricerca.",
      exportCsv: "Esporta CSV", downloadPlate: "Scarica targa PDF", downloadAllPlates: "Targhe ZIP",
      duplicate: "Duplica macchina", duplicated: "Macchina duplicata — modifica nome e matricola",
      filterAll: "Tutte", filterWith: "Con fascicolo", filterWithout: "Senza fascicolo",
      photoUpload: "Carica foto macchina", photoChange: "Cambia foto", photoRemove: "Rimuovi foto",
      photoSaved: "Foto aggiornata", photoRemoved: "Foto rimossa", photoError: "Errore con la foto (PNG/JPG/WEBP, max 8 MB)",
      descLabel: "Descrizione (visibile sulla pagina pubblica QR)",
      descPlaceholder: "Descrizione libera della macchina, uso previsto, caratteristiche...",
      guideBtn: "Guida rapida",
      guideError: "Guida disponibile per i piani attivi",
      limitNearTitle: "Stai per raggiungere il limite del tuo pacchetto archivio ({used} su {limit} macchine con documenti)",
      limitNearSub: "Quando raggiungi il limite non potrai caricare documenti su nuove macchine. Valuta il passaggio a un pacchetto superiore.",
      limitReachedTitle: "Limite del pacchetto archivio raggiunto",
      limitReachedSub: "Hai utilizzato tutti gli slot del tuo pacchetto: per caricare documenti su altre macchine passa al pacchetto superiore.",
      limitCta: "Passa ad Archivio Pro · €599",
      videoLabel: "Link video (YouTube o altro) — visibile sulla pagina pubblica QR",
      subActive: "Abbonamento attivo", subInactive: "Abbonamento non attivo", archiveNone: "Nessun pacchetto archivio",
      archiveLabel: "Archivio", manualsLabel: "manuali", fascicoloBadge: "Fascicolo Pro attivo",
      plateColor: "Colore sfondo targa", plateDark: "Sfondo Scuro", plateLight: "Sfondo Chiaro", plateCustom: "Personalizzato",
      applyQr: "Applica QR sul manuale",
      errSubscription: "Abbonamento richiesto: attiva il piano dalla sezione Piani di certificoqr.com.",
      errArchive: "Pacchetto archivio richiesto per caricare i manuali: acquistalo dalla sezione Piani.",
      errArchiveLimit: "Hai raggiunto il limite di manuali del tuo pacchetto archivio.",
      managePortal: "Gestisci abbonamento e fatture",
      errStorageLimit: "Hai raggiunto il limite di spazio per Manuali + Dichiarazioni del tuo pacchetto. Passa a Fascicolo Pro o contattaci per più spazio.",
      storageNearTitle: "Spazio documenti quasi esaurito ({used} GB su {limit} GB)",
      storageNearSub: "Lo spazio per Manuali + Dichiarazioni di Conformità del tuo pacchetto è quasi pieno.",
      storageReachedTitle: "Limite di spazio documenti raggiunto ({limit} GB)",
      storageReachedSub: "Non puoi caricare altri Manuali o Dichiarazioni: passa a Fascicolo Pro o contattaci per aumentare lo spazio.",
      storageCta: "Passa a Fascicolo Pro · €999",
      adminBtn: "Admin",
      impersonating: "Modalità assistenza: stai operando come {email}",
      impersonateExit: "Esci e torna al login admin",
      upgradeTitle: "Abbonamento non attivo",
      upgradeSub: "Attiva l'abbonamento per generare e scaricare le targhe QR dei tuoi macchinari.",
      upgradeMonthly: "Mensile", upgradeAnnual: "Annuale",
      upgradeCta: "Attiva Abbonamento",
    },
    admin: {
      title: "Area Super Admin", clients: "Clienti", newClient: "Nuovo cliente",
      email: "Email cliente", packages: "Pacchetti attivi",
      pkgMonthly: "A) Abbonamento Mensile QR Code — €19/mese",
      pkgAnnual: "B) Abbonamento Annuale QR Code — €190/anno",
      pkgArchiveBase: "C) Pacchetto Archivio Base — €149 una tantum",
      pkgArchivePro: "D) Pacchetto Archivio Pro — €599 una tantum",
      pkgFascicolo: "E) Pacchetto Fascicolo Pro — €999 una tantum",
      overrides: "Limiti personalizzati (override)",
      ovHint: "Lascia vuoto per usare il limite standard del pacchetto.",
      ovArchive: "Spazio Manuale + Dichiarazione (GB) — standard 2",
      ovQuota: "Spazio Fascicolo Tecnico per macchina (GB) — standard 5",
      ovMaxFile: "Limite singolo file Fascicolo (MB) — standard 100",
      ovShortArchive: "Docs", ovShortQuota: "Fascicolo", ovShortFile: "File",
      create: "Crea account cliente", creating: "Salvataggio...",
      save: "Salva modifiche", saved: "Piano cliente aggiornato",
      created: "Account creato", createdExisting: "Account già esistente: piano assegnato",
      tempPwd: "Password temporanea (mostrata una sola volta)",
      copy: "Copia", copied: "Password copiata",
      pwdNote: "Copiala e inviala al cliente: potrà poi cambiarla in autonomia con \"Password dimenticata\" dalla pagina di accesso.",
      machines: "macchine", storage: "documenti",
      noClients: "Nessun cliente ancora.",
      edit: "Modifica piano", back: "Indietro",
      badgeMonthly: "Abb. Mensile", badgeAnnual: "Abb. Annuale", badgeArchive: "Archivio", none: "Nessun pacchetto",
      errExists: "Cliente già presente: usa Modifica piano dalla lista.",
      errEmail: "Email non valida", errOverride: "Override sotto il valore minimo del pacchetto", error: "Errore, riprova",
      note: "Nota / motivo della modifica (facoltativa, salvata nello storico)",
      history: "Storico modifiche", historyEmpty: "Nessuna modifica registrata.",
      logCreate: "Creazione account", logUpdate: "Modifica piano", logReset: "Reset password", logImpersonate: "Accesso come cliente",
      resetPwd: "Reset password",
      resetConfirm: "Generare una nuova password temporanea per questo cliente? Quella attuale smetterà di funzionare.",
      resetDone: "Nuova password generata",
      by: "da",
      fSubscription: "Abbonamento", fArchive: "Archivio", fFascicolo: "Fascicolo",
      fStorage: "Spazio documenti", fQuota: "Spazio fascicolo", fMaxFile: "Max file",
      impersonate: "Accedi come cliente",
      impersonateShort: "Accedi",
      openPage: "Apri pagina completa",
      impersonateConfirm: "Accedere alla dashboard come {email}? La tua sessione admin verrà sostituita: per tornare admin dovrai rifare il login.",
      impersonateNoUser: "Nessun account di accesso trovato per questo cliente.",
      pwdEmailed: "Al cliente è stata inviata un'email di benvenuto da certificoqr@aldebran.com con il link per impostare la propria password (nessuna password in chiaro via email).",
    },
    scans: {
      title: "Storico scansioni", badge: "scansioni", one: "scansione",
      empty: "Nessuna scansione registrata. Ogni apertura della pagina QR pubblica comparirà qui.",
      sub: "Ogni scansione della targa QR viene registrata con data e ora.",
      week: "Ultimi 7 giorni",
    },
    share: {
      title: "Invia la pagina QR via email", sub: "Il destinatario riceverà il link alla documentazione pubblica di questo macchinario.",
      emailLabel: "Email del destinatario", send: "Invia email", sending: "Invio in corso...",
      sent: "Email inviata al destinatario", invalid: "Indirizzo email non valido",
      undeliverable: "Indirizzo email non raggiungibile", error: "Invio non riuscito, riprova",
    },
    pub: {
      overline: "Targa Digitale QR", docsTitle: "Documentazione tecnica",
      manual: "Manuale d'istruzione", declaration: "Dichiarazione di Conformità UE",
      open: "Apri PDF", notAvailable: "Non disponibile", specs: "Dati tecnici", watchVideo: "Guarda il video della macchina",
      manufacturer: "Fabbricante", model: "Modello", serial: "Numero di serie", year: "Anno di costruzione",
      notFoundTitle: "Macchinario non trovato", notFoundSub: "Il QR Code scansionato non corrisponde a nessun macchinario registrato.",
      backHome: "Vai a Certifico QR", verified: "Documentazione conforme al Regolamento Macchine UE 2023/1230",
      registered: "Registrato il",
    },
    plate: {
      preview: "Anteprima targa", title: "Targa Digitale", scan: "Scansiona per la documentazione tecnica",
      send: "Genera PDF targa", sending: "Generazione in corso...", close: "Chiudi", data: "Dati macchinario",
      hint: "Questa è l'anteprima della targa. Avvia la generazione per ricevere il PDF pronto da stampare.",
      download: "Scarica targa PDF in altre lingue",
    },
    legalPages: {
      updated: "Ultimo aggiornamento: giugno 2026",
      back: "Torna alla home",
      privacy: {
        title: "Privacy Policy",
        sections: [
          { h: "1. Titolare del trattamento", p: "Certifico QR è il titolare del trattamento dei dati personali raccolti tramite questa piattaforma. Per qualsiasi richiesta relativa alla privacy è possibile scrivere a certificoqr@aldebran.com." },
          { h: "2. Dati raccolti", p: "Raccogliamo l'indirizzo email fornito in fase di registrazione e i dati tecnici dei macchinari inseriti volontariamente dai fabbricanti (nome, modello, numero di serie, anno, documentazione PDF). Non raccogliamo dati sensibili." },
          { h: "3. Finalità del trattamento", p: "I dati sono trattati esclusivamente per fornire il servizio di targa digitale QR: autenticazione dell'account, archiviazione decennale della documentazione tecnica e generazione delle targhe conformi al Regolamento Macchine UE 2023/1230." },
          { h: "4. Conservazione e sicurezza", p: "La documentazione tecnica è conservata per 10 anni in conformità agli obblighi normativi. I dati di autenticazione sono gestiti tramite Supabase con crittografia in transito e a riposo." },
          { h: "5. Diritti dell'interessato", p: "Ai sensi del GDPR (Reg. UE 2016/679) è possibile richiedere in qualsiasi momento accesso, rettifica, cancellazione o portabilità dei propri dati scrivendo a certificoqr@aldebran.com." },
        ],
      },
      terms: {
        title: "Termini di Servizio",
        sections: [
          { h: "1. Oggetto del servizio", p: "Certifico QR fornisce una piattaforma SaaS per la digitalizzazione della documentazione tecnica dei macchinari industriali tramite targhe QR Code, in conformità al Regolamento Macchine UE 2023/1230." },
          { h: "2. Responsabilità del fabbricante", p: "Il fabbricante è l'unico responsabile della correttezza, completezza e validità legale dei dati tecnici e dei documenti caricati sulla piattaforma, incluse le Dichiarazioni di Conformità UE." },
          { h: "3. Disponibilità del servizio", p: "Certifico QR si impegna a garantire la massima disponibilità del servizio e l'accessibilità decennale della documentazione archiviata, salvo interventi di manutenzione programmata." },
          { h: "4. Limitazione di responsabilità", p: "Certifico QR non è responsabile per danni derivanti da un uso improprio della piattaforma o dall'inserimento di dati errati da parte dell'utente." },
          { h: "5. Modifiche ai termini", p: "Ci riserviamo il diritto di aggiornare i presenti termini. Le modifiche sostanziali saranno comunicate via email agli utenti registrati con almeno 30 giorni di preavviso." },
        ],
      },
      cookie: {
        title: "Cookie Policy",
        sections: [
          { h: "1. Cosa sono i cookie", p: "I cookie sono piccoli file di testo salvati dal browser durante la navigazione. Certifico QR utilizza esclusivamente cookie tecnici, indispensabili al funzionamento del servizio." },
          { h: "2. Cookie utilizzati", p: "Utilizziamo cookie di sessione per l'autenticazione (gestiti da Supabase) e una preferenza locale per la lingua dell'interfaccia (IT/EN). Non utilizziamo cookie di profilazione né di marketing." },
          { h: "3. Cookie di terze parti", p: "Non installiamo cookie di terze parti a fini pubblicitari. I soli servizi esterni coinvolti (Supabase per l'autenticazione) operano come responsabili del trattamento." },
          { h: "4. Gestione dei cookie", p: "È possibile eliminare i cookie tramite le impostazioni del browser. La disattivazione dei cookie tecnici può compromettere l'accesso alla dashboard." },
        ],
      },
    },
  },
  en: {
    nav: { how: "How it works", features: "Features", sectors: "Sectors", book: "Book", pricing: "Plans", contact: "Contact", login: "Log in", cta: "Try the Dashboard" },
    book: {
      badge: "New release — Aldebran Edizioni",
      title: "Il Regolamento Europeo Macchine 2023/1230",
      subtitle: "From Directive 2006/42/EC to the new European framework",
      desc: "The practical guide to the new EU Machinery Regulation 2023/1230: manufacturer obligations, CE marking, risk assessment and machine safety in the transition from the Machinery Directive 2006/42/EC to the new European framework. An operational tool for manufacturers, designers and consultants adapting technical documentation and processes to the new rules.",
      author: "Author", authorName: "Antonio Del Mastro",
      publisher: "Publisher", publisherName: "Aldebran Edizioni",
      date: "Published", dateValue: "18 October 2026",
      format: "Format", formatValue: "Hardcover",
      cta: "Buy on Amazon",
      note: "Available on Amazon.it (Italian edition)",
    },
    hero: {
      overline: "EU Machinery Regulation 2023/1230",
      title1: "Machine compliance",
      title2: "for your equipment",
      title3: "one QR Code away",
      subtitle:
        "Digitize the Technical File, instruction manuals and drawings of your industrial machinery in full compliance with the EU Machinery Regulation 2023/1230. Legally compliant retention for 10 years.",
      cta: "Try the Manufacturers Dashboard",
      secondary: "See how it works",
      stat1: "Years of guaranteed archiving",
      stat2: "Regulatory compliance",
      stat3: "On-site access",
    },
    marquee: ["ISO 9001", "EU 2023/1230", "COMPLIANCE", "INDUSTRIAL SAFETY", "EU DECLARATION", "QR CODE", "10-YEAR ARCHIVE"],
    features: {
      overline: "The platform",
      title: "Everything you need for digital compliance",
      subtitle: "Four pillars to manage your machinery's technical documentation, from manufacturer to inspector.",
      items: [
        { t: "Digital Plate Generation", d: "Dynamic QR Code creation for every machine, unique and always traceable." },
        { t: "Technical File & Secure Cloud", d: "Protected hosting of manuals, EU Declarations and the technical file for 10 years: custom folders, notes, global search, document preview and a printable PDF report with your logo." },
        { t: "Mobile Optimization", d: "Immediate, seamless access right on the field for operators and inspectors." },
        { t: "Print Automation", d: "Instant generation of the print-ready plate layout PDF, directly from the platform." },
      ],
    },
    how: {
      overline: "How it works",
      title: "From desk to machine in three steps",
      steps: [
        { t: "Enter technical data", d: "Record the machine's technical data in your private, protected dashboard." },
        { t: "Upload documents and the Technical File", d: "Attach instruction manuals, CE/EU Declarations and the full technical file in extended formats (up to 100MB per file)." },
        { t: "Generate and apply the QR", d: "Generate the QR Code label directly from the platform and apply it to the machine." },
      ],
    },
    cta: { title: "Ready to digitize compliance?", subtitle: "Activate your Manufacturers Dashboard and generate your first digital plate in minutes.", button: "Get started" },
    sectors: {
      overline: "Sectors",
      title: "One platform for every compliance need",
      items: [
        { tag: "ISO 9001", t: "Quality", d: "Document control at the point of use. Update operating instructions in the cloud while the QR on the shop floor stays identical. Inspection audits always passed, with no outdated paper." },
        { tag: "PED", t: "Pressure", d: "Ten-year, tamper-proof archiving of declarations and material certificates (3.1) directly on valves or tanks, ready for on-site inspections." },
        { tag: "ATEX", t: "Explosive atmospheres", d: "Instant at-machine consultation of mandatory maintenance logs and component safety limits in hazardous areas." },
        { tag: "MDR", t: "Medical devices", d: "Immediate availability of user manuals and device certificates for healthcare operators and post-market surveillance." },
        { tag: "MAINTENANCE", t: "Workshops & Plants", d: "Pair QR codes with machine data sheets and plant equipment in any industry. Manage scheduled maintenance, calibration deadlines, periodic inspection reports and historical logs on the go, right on site — eliminating search time in the workshop." },
        { tag: "CONSUMER", t: "Consumer Products", d: "Get ahead of the EU DPP (Digital Product Passport) requirement. Replace paper manuals for appliances, IoT and tech products with a QR Code offering multilingual manuals, recycling and disposal guides, and warranty registration." },
        { tag: "CYBERSECURITY", t: "Security Software", d: "Verify the integrity of industrial software and safety PLCs at the machine. Place the QR Code directly on HMI screens or in the code to track Software Bills of Materials (SBOM), security patches and tamper-proof logs (Cyber Resilience Act)." },
        { tag: "AUTOMATION", t: "Electrical Panels", d: "Link every electrical panel, PLC or on-board system to its up-to-date schematics, test reports and component lists. Simplify field maintenance and after-sales service by eliminating paper binders." },
        { tag: "AEROSPACE", t: "Aerospace & Defence", d: "Trace every critical component with maximum accuracy and manage complex aeronautical compliance documentation. Guarantee instant availability of material certificates, test reports and historical inspection records." },
        { tag: "CONSULTING", t: "Management Systems", d: "Digitize the points of use of company workflows related to Quality, Safety and Environment (ISO 9001, 14001, 45001). Give consultants and internal auditors instant access to controlled procedures, audit minutes and compliance checklists." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your machine fleet",
      subtitle: "Questions about the platform, the packages, or want a guided demo? Write to us: we reply within one business day.",
      nameLabel: "Name / Company",
      namePlaceholder: "John Smith — Smith Machinery Ltd",
      messageLabel: "Message",
      messagePlaceholder: "Tell us about your needs: how many machines you manage, which documentation you want to digitize...",
      cta: "Send request",
      success: "Request sent successfully!",
      error: "Sending failed. Please try again shortly.",
      tooMany: "Too many requests: try again in an hour.",
      sentTitle: "Thank you, message received!",
      sentSub: "We will get back to you as soon as possible at the email address provided.",
    },
    pricing: {
      overline: "Plans & Pricing",
      title: "A plan for every machine fleet",
      subtitle: "Software subscription and legal archiving kept separate: pay only for what you need.",
      platform: {
        heading: "Platform Subscription",
        desc: "QR plate generation and Manufacturers Dashboard.",
        monthly: "Monthly", annual: "Annual",
        priceMonthly: "€19", perMonth: "/month",
        priceAnnual: "€190", perYear: "/year",
        annualBadge: "2 months free",
        features: [
          "Unlimited QR code generation and machines",
          "Full access to the Manufacturers Dashboard",
          "Edit machine data at any time",
          "Instant plate sharing via email to your clients",
          "Shareable public QR page (/m/{id}) optimized in 5 EU languages",
          "Machine photo, description and video link on the public page",
          "QR scan statistics in the Dashboard: totals, dated history with locations, CSV export",
          "One-click machine duplication",
          "Manufacturer logo displayed on the public page",
          "Visual digital plate preview included",
          "Technical support via email",
        ],
        cta: "Activate subscription",
      },
      archive: {
        heading: "10-Year Legal Archiving Packages",
        desc: "Protected upload of mandatory manuals, stored for 10 years. One-time payment.",
        oneTime: "One-time",
        plans: [
          { name: "Archive Base Package", price: "€149", features: [
            "Protected, secured archive for up to 10 machines",
            "Upload of ONLY the Instruction Manual and the CE/EU Declaration for each machine",
            "Visual editor to apply the QR plate directly onto the PDF manual and the CE/EU Declaration",
            "Digital and legal retention guaranteed for 10 years (Machinery Regulation)",
            "Immediate public consultation of documents via QR Code",
            "Institutional plate layout with co-branding (Client logo top-left + CertificoQR logo top-right)",
            "Automatic lock when the 10-manual limit is reached",
            "Automatic VAT calculation at checkout and legally compliant Italian invoicing",
          ] },
          { name: "Archive Pro Package", price: "€599", features: [
            "Protected company archive for up to 100 machines",
            "Upload of ONLY the Instruction Manual and the CE/EU Declaration for each machine",
            "Visual editor to apply the QR plate directly onto the PDF manual and the CE/EU Declaration",
            "Digital and legal retention guaranteed for 10 years (Machinery Regulation)",
            "Advanced institutional plate layout with dual logo (Company + CertificoQR)",
            "Bulk export of machine data in CSV format",
            "Instant download of all generated plates in a single ZIP package",
            "Native Stripe Customer Portal integration in the Dashboard for self-service invoices and receipts",
            "Automatic lock when the 100-manual limit is reached",
          ] },
          { name: "Fascicolo Pro Package", price: "€999", features: [
            "Complete Technical File archiving (Machinery Directive)",
            "Up to 100 machines with documents and linked technical file",
            "Up to 5 GB of total storage per machine",
            "Extended format support (PDF, Word, images, CAD drawings DWG/DXF)",
            "Single-file size limit raised to 100 MB",
            "Organization in custom folders and subfolders with per-document notes",
            "Global document search, PDF/image preview and full-file ZIP download",
            "Printable PDF report of the technical file with your company logo, including a single fleet-wide report",
            "Legal and immutable retention for 10 years",
            "Advanced plate layout with co-branding (Company + CertificoQR)",
            "Bulk CSV export and ZIP download of all plates",
          ] },
        ],
        cta: "Buy the package",
      },
      faq: {
        title: "Frequently asked questions",
        items: [
          { q: "Which documents can I upload?", a: "With the Archive Base and Pro packages you can upload compliance documents, ISO operating instructions, PED/ATEX/MDR certificates and consumer manuals. With the Fascicolo Pro package you also unlock the upload of the full internal technical file (CAD DWG/DXF drawings, reports, cybersecurity logs and risk analyses) up to 5 GB per machine." },
          { q: "How do I organize and browse the Technical File?", a: "The technical file is organized in custom folders and subfolders (up to 3 levels), with the ability to move documents and add notes. Find any document with the global search across all machines, preview it without downloading, and export the entire file as a ZIP or generate a printable PDF report with the document index and your company logo." },
          { q: "What does the customer see when scanning the QR Code?", a: "The customer opens the machine's public page with photo, description, presentation video (if uploaded), highlighted technical data and the available public documents (Instruction Manual and CE/EU Declaration). The internal Technical File always remains private and visible only to the manufacturer in the Dashboard." },
          { q: "How does invoicing work?", a: "At Stripe checkout, VAT is calculated automatically and you receive a legally compliant Italian invoice with the tax data you provide (VAT number, tax code, company name)." },
          { q: "Can I cancel my subscription anytime?", a: "Yes. From the Dashboard you access the Stripe Customer Portal to manage cancellation, invoices and receipts on your own. The subscription stays active until the end of the paid period." },
          { q: "What happens when I reach the manuals limit?", a: "Uploads lock automatically once the package limit is reached (10 or 100 manuals). You can upgrade to the Archive Pro Package at any time to extend your space." },
        ],
      },
      compare: {
        title: "Archive packages comparison",
        intro: "We don't sell plain cloud storage: CertificoQR is a legally structured, tamper-proof and immutable archive protecting the manufacturer's criminal liability for 10 years.",
        base: "Archive Base", pro: "Archive Pro", fascicolo: "Fascicolo Pro",
        rows: [
          { f: "Archived machines", b: "10", p: "100", x: "100" },
          { f: "Manual + CE/EU Declaration per machine", b: "✓", p: "✓", x: "✓" },
          { f: "Legal, immutable 10-year retention", b: "✓", p: "✓", x: "✓" },
          { f: "Public consultation via QR Code", b: "✓", p: "✓", x: "✓" },
          { f: "Public page with machine photo, description and video", b: "✓", p: "✓", x: "✓" },
          { f: "QR scan statistics with detailed history and CSV export", b: "✓", p: "✓", x: "✓" },
          { f: "Co-branded plate (dual logo)", b: "✓", p: "✓ advanced", x: "✓ advanced" },
          { f: "Bulk CSV export", b: "—", p: "✓", x: "✓" },
          { f: "ZIP download of all plates", b: "—", p: "✓", x: "✓" },
          { f: "Stripe Customer Portal in Dashboard", b: "—", p: "✓", x: "✓" },
          { f: "QR applied onto the PDF manual (visual editor)", b: "✓", p: "✓", x: "—" },
          { f: "Full Technical File archiving (CAD DWG/DXF drawings, images, files up to 100MB, 5GB per machine)", b: "—", p: "—", x: "✓" },
          { f: "Custom folders and subfolders, notes, global search and document preview", b: "—", p: "—", x: "✓" },
          { f: "PDF report of the technical file with company logo (single machine and full fleet)", b: "—", p: "—", x: "✓" },
          { f: "ZIP download of the entire technical file with folder structure", b: "—", p: "—", x: "✓" },
          { f: "One-time price", b: "€149", p: "€599", x: "€999" },
        ],
      },
    },
    thanks: {
      title: "Thank you for your purchase!",
      subtitle: "Your payment was successful. Your plan will be activated automatically within moments.",
      emailNote: "Important: activation applies to the CertificoQR account registered with the same email used for payment. If you don't have an account yet, sign up with that email.",
      ctaRegister: "Create your account",
      ctaLogin: "Go to Dashboard",
      checking: "We're verifying your plan activation...",
      timeout: "Activation is taking longer than expected: open the dashboard, your plan will appear shortly. Support: certificoqr@aldebran.com",
      activated: "Plan activated! Taking you to the dashboard...",
      goDashboard: "Go to Dashboard",
    },
    about: {
      title: "About us",
      overline: "Company",
      text: "CertificoQR is a service by Aldebran",
      website: "www.aldebran.com",
      address: "Via Dalmine, 10a · 24035 Curno (BG), Italy",
      phone: "+39 035 0167428",
      email: "certificoqr@aldebran.com",
      back: "Back to home",
    },
    footer: {
      tagline: "Your machine compliance, digitized.",
      product: "Product", legal: "Legal", company: "Company",
      links: { features: "Features", how: "How it works", dashboard: "Dashboard", privacy: "Privacy Policy", terms: "Terms of Service", cookie: "Cookie Policy", about: "About us", contact: "Contact", support: "Support" },
      rights: "All rights reserved.",
    },
    auth: {
      loginTitle: "Sign in to your dashboard", loginSub: "Manage your machinery compliance.",
      forgotLink: "Forgot password?", backToLogin: "Back to login",
      forgotTitle: "Recover your password", forgotSub: "We'll email you a link to reset it.",
      forgotCta: "Send recovery link",
      forgotSent: "If an account exists for that email, you'll receive a recovery link shortly.",
      resetTitle: "Set a new password", resetValidating: "Validating recovery link...",
      resetInvalid: "This recovery link is invalid or has expired. Request a new one from the login page.",
      resetNew: "New password", resetConfirm: "Confirm password",
      resetTooShort: "Use at least 8 characters.", resetMismatch: "Passwords do not match.",
      resetCta: "Update password", resetDone: "Password updated! Taking you back to login...",
      regTitle: "Create your account", regSub: "Activate the Manufacturers Dashboard in seconds.",
      email: "Email", password: "Password", login: "Log in", register: "Sign up",
      noAccount: "Don't have an account?", haveAccount: "Already have an account?", signup: "Sign up", signin: "Log in",
      confirm: "Check your email to confirm your account, then log in.", back: "Back to home",
    },
    adminReq: {
      title: "Contact requests from the website",
      empty: "No requests received.",
      sent: "Email forwarded",
      pending: "Email queued (will be sent when the domain recovers)",
      deleted: "Request deleted",
      error: "Operation failed",
      newOne: "new", newMany: "new", newChip: "NEW",
      markRead: "Mark all as read",
      marked: "Requests marked as read",
    },
    stats: {
      title: "Scan Overview",
      total: "Total scans",
      thisMonth: "This month",
      showDetail: "Show scan detail",
      hideDetail: "Hide detail",
      exportCsv: "Export CSV",
      exportError: "Export failed",
      top: "Most scanned machine",
      chart: "Last 12 months",
    },
    dossier: {
      title: "Technical File",
      regulation: "EU Machinery Regulation 2023/1230",
      privateNote: "Confidential internal documentation: visible only in this dashboard, never on the public QR page.",
      required: "The Technical File requires the Fascicolo Pro Package (€999 one-time): buy it from the Plans section on certificoqr.com.",
      category: "Document category",
      categories: {
        drawings: "Overall drawings and diagrams",
        calculations: "Calculations and technical tests",
        risk: "Risk assessment",
        standards: "Applied standards",
        other: "Other documents",
      },
      upload: "Upload file",
      formats: "Formats: PDF, DOC/DOCX, DWG, DXF, PNG, JPG · max 100MB per file",
      space: "File storage",
      empty: "No documents in the technical file yet. Upload drawings, calculations and risk assessments.",
      uploaded: "Document added to the technical file",
      deleted: "Document deleted",
      confirmDelete: "Delete this document from the technical file?",
      badFormat: "Format not allowed (PDF, DOC/DOCX, DWG, DXF, PNG, JPG)",
      tooLarge: "File too large (max {max})",
      quotaFull: "Technical file storage full (max {quota} per machine)",
      uploadError: "Upload error",
      downloadError: "Download error",
      download: "Download",
      delete: "Delete",
      open: "Tech File",
      foldersLabel: "Technical file folders",
      newFolder: "New folder",
      folderName: "Folder name (free or preset)",
      uploadInto: "Upload into folder",
      noFolders: "No folders yet. Create your first folder to organize the technical file: name it freely or pick a preset name.",
      rename: "Rename",
      folderCreated: "Folder created",
      folderRenamed: "Folder renamed",
      folderDeleted: "Folder deleted",
      folderNotEmpty: "The folder contains files or subfolders: move or delete them first",
      subFolder: "Subfolder",
      moveFile: "Move to another folder",
      moved: "Document moved",
      maxDepth: "Maximum depth reached (3 levels)",
      zipBtn: "Download ZIP",
      zipStarted: "Technical file download started",
      search: "Search document...",
      noResults: "No documents found",
      preview: "Preview",
      globalTitle: "Global search in the Technical File",
      globalPlaceholder: "Search a document across all machines...",
      noteLabel: "Note",
      notePlaceholder: "Add a note to this document...",
      noteSaved: "Note saved",
      docOne: "document",
      docMany: "documents",
      reportBtn: "PDF Report",
      reportStarted: "Report download started",
      reportAllBtn: "Full PDF report",
    },
    qredit: {
      title: "Apply QR onto the Manual",
      subtitle: "Drag and resize the QR box to the desired spot on the page, then save.",
      page: "Page",
      of: "of",
      save: "Stamp QR onto PDF",
      saving: "Generating PDF...",
      saved: "QR stamped onto the manual successfully",
      restore: "Restore original",
      restored: "Original manual restored",
      stampedNote: "This manual already has a stamped QR: repositioning always starts from the clean original PDF.",
      error: "Operation failed, please retry",
      loadError: "Unable to load the manual",
      previewBtn: "Stamp preview",
      previewNote: "Exact preview of the stamped page: if the position is right, save; otherwise go back to editing.",
      backEdit: "Edit position",
      guideTitle: "How the editor works",
      guideSteps: [
        "Drag the QR box to the desired spot on the page",
        "Resize it with the green handle at the bottom right",
        "Check the result with \"Stamp preview\"",
        "Save: the PDF is regenerated with the QR stamped on it",
      ],
      guideOk: "Got it, let's start",
      hint: "The QR stays black on a white box with the serial number, ensuring perfect printing and scanning.",
    },
    dash: {
      title: "Manufacturers Dashboard", welcome: "Welcome", logout: "Log out",
      add: "New machine", empty: "No machines registered yet. Add your first one to generate the digital plate.",
      name: "Machine name", model: "Model", serial: "Serial number", manufacturer: "Manufacturer", year: "Year of construction",
      manual: "Manual URL (PDF)", declaration: "EU Declaration URL (PDF)", save: "Save machine", cancel: "Cancel",
      generate: "Generate QR plate", generating: "Generating...", generated: "Plate generated", viewPdf: "View PDF", delete: "Delete",
      count: "machines registered",
      manualFile: "Instruction manual (PDF)", declFile: "EU Declaration (PDF)", optional: "Optional",
      uploadHint: "Upload a PDF file (max 20MB)", uploading: "Uploading documents...", docs: "Documents",
      manualShort: "Manual", declShort: "EU Declaration",
      companyLogo: "Company logo",
      edit: "Edit", editTitle: "Edit machine", updateSave: "Save changes", updatedToast: "Machine updated",
      search: "Search by name, serial or manufacturer...", noResults: "No machines match your search.",
      exportCsv: "Export CSV", downloadPlate: "Download plate PDF", downloadAllPlates: "Plates ZIP",
      duplicate: "Duplicate machine", duplicated: "Machine duplicated — edit name and serial number",
      filterAll: "All", filterWith: "With technical file", filterWithout: "Without technical file",
      photoUpload: "Upload machine photo", photoChange: "Change photo", photoRemove: "Remove photo",
      photoSaved: "Photo updated", photoRemoved: "Photo removed", photoError: "Photo error (PNG/JPG/WEBP, max 8 MB)",
      descLabel: "Description (visible on the public QR page)",
      descPlaceholder: "Free description of the machine, intended use, features...",
      guideBtn: "Quick guide",
      guideError: "Guide available for active plans",
      limitNearTitle: "You are approaching your archive package limit ({used} of {limit} machines with documents)",
      limitNearSub: "Once the limit is reached you won't be able to upload documents to new machines. Consider upgrading your package.",
      limitReachedTitle: "Archive package limit reached",
      limitReachedSub: "You have used all the slots of your package: upgrade to upload documents to more machines.",
      limitCta: "Upgrade to Archive Pro · €599",
      videoLabel: "Video link (YouTube or other) — visible on the public QR page",
      subActive: "Subscription active", subInactive: "Subscription inactive", archiveNone: "No archive package",
      archiveLabel: "Archive", manualsLabel: "manuals", fascicoloBadge: "Fascicolo Pro active",
      plateColor: "Plate background color", plateDark: "Dark Background", plateLight: "Light Background", plateCustom: "Custom",
      applyQr: "Apply QR onto manual",
      errSubscription: "Subscription required: activate a plan from the Plans section on certificoqr.com.",
      errArchive: "Archive package required to upload manuals: buy one from the Plans section.",
      errArchiveLimit: "You have reached your archive package manual limit.",
      managePortal: "Manage subscription & invoices",
      errStorageLimit: "You have reached your package's storage limit for Manuals + Declarations. Upgrade to Fascicolo Pro or contact us for more space.",
      storageNearTitle: "Document storage almost full ({used} GB of {limit} GB)",
      storageNearSub: "Your package's storage for Manuals + Declarations of Conformity is almost full.",
      storageReachedTitle: "Document storage limit reached ({limit} GB)",
      storageReachedSub: "You can't upload more Manuals or Declarations: upgrade to Fascicolo Pro or contact us to increase your space.",
      storageCta: "Upgrade to Fascicolo Pro · €999",
      adminBtn: "Admin",
      impersonating: "Support mode: you are operating as {email}",
      impersonateExit: "Exit and return to admin login",
      upgradeTitle: "Subscription inactive",
      upgradeSub: "Activate a subscription to generate and download QR plates for your machines.",
      upgradeMonthly: "Monthly", upgradeAnnual: "Annual",
      upgradeCta: "Activate Subscription",
    },
    admin: {
      title: "Super Admin Area", clients: "Clients", newClient: "New client",
      email: "Client email", packages: "Active packages",
      pkgMonthly: "A) QR Code Monthly Subscription — €19/month",
      pkgAnnual: "B) QR Code Annual Subscription — €190/year",
      pkgArchiveBase: "C) Archive Base Package — €149 one-off",
      pkgArchivePro: "D) Archive Pro Package — €599 one-off",
      pkgFascicolo: "E) Fascicolo Pro Package — €999 one-off",
      overrides: "Custom limits (override)",
      ovHint: "Leave empty to use the package's standard limit.",
      ovArchive: "Manual + Declaration storage (GB) — standard 2",
      ovQuota: "Technical File storage per machine (GB) — standard 5",
      ovMaxFile: "Technical File single file limit (MB) — standard 100",
      ovShortArchive: "Docs", ovShortQuota: "Dossier", ovShortFile: "File",
      create: "Create client account", creating: "Saving...",
      save: "Save changes", saved: "Client plan updated",
      created: "Account created", createdExisting: "Account already exists: plan assigned",
      tempPwd: "Temporary password (shown only once)",
      copy: "Copy", copied: "Password copied",
      pwdNote: "Copy it and send it to the client: they can later change it via \"Forgot password\" on the login page.",
      machines: "machines", storage: "documents",
      noClients: "No clients yet.",
      edit: "Edit plan", back: "Back",
      badgeMonthly: "Monthly Sub", badgeAnnual: "Annual Sub", badgeArchive: "Archive", none: "No package",
      errExists: "Client already exists: use Edit plan from the list.",
      errEmail: "Invalid email", errOverride: "Override below the package minimum", error: "Error, please retry",
      note: "Note / reason for the change (optional, saved in history)",
      history: "Change history", historyEmpty: "No changes recorded.",
      logCreate: "Account created", logUpdate: "Plan updated", logReset: "Password reset", logImpersonate: "Logged in as client",
      resetPwd: "Reset password",
      resetConfirm: "Generate a new temporary password for this client? The current one will stop working.",
      resetDone: "New password generated",
      by: "by",
      fSubscription: "Subscription", fArchive: "Archive", fFascicolo: "Fascicolo",
      fStorage: "Document storage", fQuota: "Dossier storage", fMaxFile: "Max file",
      impersonate: "Log in as client",
      impersonateShort: "Log in",
      openPage: "Open full page",
      impersonateConfirm: "Access the dashboard as {email}? Your admin session will be replaced: log in again to return as admin.",
      impersonateNoUser: "No login account found for this client.",
      pwdEmailed: "A welcome email was sent to the client from certificoqr@aldebran.com with a link to set their own password (no plaintext password via email).",
    },
    scans: {
      title: "Scan history", badge: "scans", one: "scan",
      empty: "No scans recorded yet. Every visit to the public QR page will appear here.",
      sub: "Every scan of the QR plate is recorded with date and time.",
      week: "Last 7 days",
    },
    share: {
      title: "Send the QR page by email", sub: "The recipient will receive the link to this machine's public documentation.",
      emailLabel: "Recipient email", send: "Send email", sending: "Sending...",
      sent: "Email sent to the recipient", invalid: "Invalid email address",
      undeliverable: "Email address unreachable", error: "Sending failed, please retry",
    },
    pub: {
      overline: "Digital QR Plate", docsTitle: "Technical documentation",
      manual: "Instruction manual", declaration: "EU Declaration of Conformity",
      open: "Open PDF", notAvailable: "Not available", specs: "Technical data", watchVideo: "Watch the machine video",
      manufacturer: "Manufacturer", model: "Model", serial: "Serial number", year: "Year of construction",
      notFoundTitle: "Machine not found", notFoundSub: "The scanned QR Code does not match any registered machine.",
      backHome: "Go to Certifico QR", verified: "Documentation compliant with EU Machinery Regulation 2023/1230",
      registered: "Registered on",
    },
    plate: {
      preview: "Plate preview", title: "Digital Plate", scan: "Scan for technical documentation",
      send: "Generate plate PDF", sending: "Generating...", close: "Close", data: "Machine data",
      hint: "This is the plate preview. Start generation to receive the print-ready PDF.",
      download: "Download plate PDF in other languages",
    },
    legalPages: {
      updated: "Last updated: June 2026",
      back: "Back to home",
      privacy: {
        title: "Privacy Policy",
        sections: [
          { h: "1. Data controller", p: "Certifico QR is the controller of personal data collected through this platform. For any privacy-related request, please write to certificoqr@aldebran.com." },
          { h: "2. Data collected", p: "We collect the email address provided at registration and the technical machine data voluntarily entered by manufacturers (name, model, serial number, year, PDF documentation). We do not collect sensitive data." },
          { h: "3. Purpose of processing", p: "Data is processed exclusively to provide the digital QR plate service: account authentication, ten-year archiving of technical documentation and generation of plates compliant with EU Machinery Regulation 2023/1230." },
          { h: "4. Retention and security", p: "Technical documentation is retained for 10 years in accordance with regulatory obligations. Authentication data is managed via Supabase with encryption in transit and at rest." },
          { h: "5. Data subject rights", p: "Under the GDPR (EU Reg. 2016/679) you may at any time request access, rectification, erasure or portability of your data by writing to certificoqr@aldebran.com." },
        ],
      },
      terms: {
        title: "Terms of Service",
        sections: [
          { h: "1. Scope of the service", p: "Certifico QR provides a SaaS platform for digitizing the technical documentation of industrial machinery through QR Code plates, in compliance with EU Machinery Regulation 2023/1230." },
          { h: "2. Manufacturer responsibility", p: "The manufacturer is solely responsible for the accuracy, completeness and legal validity of the technical data and documents uploaded to the platform, including EU Declarations of Conformity." },
          { h: "3. Service availability", p: "Certifico QR is committed to ensuring maximum service availability and ten-year accessibility of archived documentation, except for scheduled maintenance." },
          { h: "4. Limitation of liability", p: "Certifico QR is not liable for damages arising from improper use of the platform or from incorrect data entered by the user." },
          { h: "5. Changes to terms", p: "We reserve the right to update these terms. Substantial changes will be communicated by email to registered users with at least 30 days' notice." },
        ],
      },
      cookie: {
        title: "Cookie Policy",
        sections: [
          { h: "1. What cookies are", p: "Cookies are small text files saved by the browser while navigating. Certifico QR uses only technical cookies, essential for the operation of the service." },
          { h: "2. Cookies used", p: "We use session cookies for authentication (managed by Supabase) and a local preference for the interface language (IT/EN). We do not use profiling or marketing cookies." },
          { h: "3. Third-party cookies", p: "We do not install third-party cookies for advertising purposes. The only external services involved (Supabase for authentication) operate as data processors." },
          { h: "4. Managing cookies", p: "You can delete cookies through your browser settings. Disabling technical cookies may prevent access to the dashboard." },
        ],
      },
    },
  },
};
